import  normalize from 'json-api-normalize';
import { AddressModel } from './address.model';
import { MedicalSchoolModel } from './medical-school.model';
import { MediaPathHelper } from '../helpers/media-path.helper';
import { DrupalBaseModel } from './drupal-base.model';

export class InstitutionModel extends DrupalBaseModel {

  public static parseInstitutionListing(json: any): InstitutionModel[] {
    const normalizedData = normalize(json).get([
      'drupal_internal__nid',
      'path',
      'field_institution_id',
      'title',
      'field_address']);

    return normalizedData.map(institution => new InstitutionModel({
      nid: institution.drupal_internal__nid,
      cmsPath: institution.path,
      institutionNumber: institution.field_institution_id.trim(),
      name: institution.title.trim(),
      address: new AddressModel({
        state: institution.field_address.administrative_area,
      })
    }));
  }

  public static parseInstitution(institutionJson: any, baseImageUrl: string): InstitutionModel[] | InstitutionModel {
    const normalizedData = normalize(institutionJson).get([
      'drupal_internal__nid',
      'path',
      'id',
      'field_institution_id',
      'title',
      'field_address',
      'field_geolocation',
      'field_service_type',
      'field_ownership_control_type',
      'field_number_ft_personnel',
      'field_number_beds',
      'field_number_bassinets',
      'field_avg_daily_census',
      'field_annual_births',
      'field_annual_admissions',
      'field_annual_ed_visits',
      'field_annual_non_ed_visits',
      'field_inpatient_surgeries',
      'field_outpatient_surgeries',
      'field_annual_medicare_discharges',
      'field_annual_medicaid_discharges',
      'field_cardiac_icu',
      'field_surgical_icu',
      'field_pediatric_icu',
      'field_neonatal_icu',
      'field_burn_care',
      'field_physical_rehab',
      'field_psychiatric_care',
      'field_hospice',
      'field_eol_service',
      'field_trauma_center',
      'field_trauma_center_indicator',
      'field_positron_emission',
      'field_mri',
      'field_med_school_relationship',
      'field_image',
      'metatag_normalized',
      'field_member_aha_group'
    ]);

    const inst = Array.isArray(normalizedData) ? normalizedData.map(institution => new InstitutionModel({
      nid: institution.drupal_internal__nid,
      cmsPath: institution.path,
      id: institution.id,
      institutionNumber: institution.field_institution_id.trim(),
      imageUrl: institution.field_image && institution.field_image.dataset.included.filter(f => f.type === 'file--file')[0] ?
        MediaPathHelper.imageSrcUrl(institution.field_image.dataset.included.filter(f => f.type === 'file--file')[0].attributes.uri.url, baseImageUrl) : null,
      name: institution.title.trim(),
      geoLocation: institution.field_geolocation,
      address: new AddressModel({
        address1: institution.field_address.address_line1,
        address2: institution.field_address.address_line2,
        city: institution.field_address.locality,
        state: institution.field_address.administrative_area,
        zipCode: institution.field_address.postal_code,
        countryCode: institution.field_address.country_code
      }),
      serviceType: institution.field_service_type ? institution.field_service_type.dataset.data.attributes.name : null,
      ownershipType: institution.field_ownership_control_type ? institution.field_ownership_control_type.dataset.data.attributes.name : null,
      fullTimePersonnel: institution.field_number_ft_personnel,
      numOfBeds: institution.field_number_beds,
      numOfBassinet: institution.field_number_bassinets,
      avgDailyCensus: institution.field_avg_daily_census,
      annualBirths: institution.field_annual_births,
      annualAdmissions: institution.field_annual_admissions,
      annualEdVisits: institution.field_annual_ed_visits,
      annualNonEdVisits: institution.field_annual_non_ed_visits,
      inpatientSurgeries: institution.field_inpatient_surgeries,
      outpatientSurgeries: institution.field_outpatient_surgeries,
      annualMedicareDischarge: institution.field_annual_medicare_discharges,
      annualMedicaidDischarge: institution.field_annual_medicaid_discharges,
      cardiacICU: institution.field_cardiac_icu ? `${institution.field_cardiac_icu} Beds` : null,
      surgicalICU: institution.field_surgical_icu ? `${institution.field_surgical_icu} Beds` : null,
      pediatricICU: institution.field_pediatric_icu ? `${institution.field_pediatric_icu} Beds` : null,
      neonatalICU: institution.field_neonatal_icu ? `${institution.field_neonatal_icu} Beds` : null,
      burnCare: institution.field_burn_care ? `${institution.field_burn_care} Beds` : null,
      physicalRehab: institution.field_physical_rehab ? `${institution.field_physical_rehab} Beds` : null,
      psychiatricCare: institution.field_psychiatric_care ? `${institution.field_psychiatric_care} Beds` : null,
      hospice: institution.field_hospice,
      eolService: institution.field_eol_service,
      traumaCenterLevel: institution.field_trauma_center,
      traumaCenterIndicator: institution.field_trauma_center_indicator,
      positronEmission: institution.field_positron_emission,
      mri: institution.field_mri,
      metatags: institution.metatag_normalized ? institution.metatag_normalized : '',
      medicalSchools: institution.field_med_school_relationship ?
        MedicalSchoolModel.parseMedicalSchool(institution.field_med_school_relationship.dataset) as MedicalSchoolModel[] : [],
        field_member_aha_group: institution.field_member_aha_group ? institution.field_member_aha_group.dataset.data.attributes.name : null


      })) :
      new InstitutionModel({
        nid: normalizedData.drupal_internal__nid,
        cmsPath: normalizedData.path,
        id: normalizedData.id,
        institutionNumber: normalizedData.field_institution_id.trim(),
        imageUrl: normalizedData.field_image && normalizedData.field_image.dataset.included.filter(f => f.type === 'file--file')[0] ?
          MediaPathHelper.imageSrcUrl(normalizedData.field_image.dataset.included.filter(f => f.type === 'file--file')[0].attributes.uri.url, baseImageUrl) : null,
        name: normalizedData.title.trim(),
        geoLocation: normalizedData.field_geolocation,
        address: new AddressModel({
          address1: normalizedData.field_address.address_line1,
          address2: normalizedData.field_address.address_line2,
          city: normalizedData.field_address.locality,
          state: normalizedData.field_address.administrative_area,
          zipCode: normalizedData.field_address.postal_code,
          countryCode: normalizedData.field_address.country_code
        }),
        serviceType: normalizedData.field_service_type ? normalizedData.field_service_type.dataset.data.attributes.name : null,
        ownershipType: normalizedData.field_ownership_control_type ? normalizedData.field_ownership_control_type.dataset.data.attributes.name : null,
        fullTimePersonnel: normalizedData.field_number_ft_personnel,
        numOfBeds: normalizedData.field_number_beds,
        numOfBassinet: normalizedData.field_number_bassinets,
        avgDailyCensus: normalizedData.field_avg_daily_census,
        annualBirths: normalizedData.field_annual_births,
        annualAdmissions: normalizedData.field_annual_admissions,
        annualEdVisits: normalizedData.field_annual_ed_visits,
        annualNonEdVisits: normalizedData.field_annual_non_ed_visits,
        inpatientSurgeries: normalizedData.field_inpatient_surgeries,
        outpatientSurgeries: normalizedData.field_outpatient_surgeries,
        annualMedicareDischarge: normalizedData.field_annual_medicare_discharges,
        annualMedicaidDischarge: normalizedData.field_annual_medicaid_discharges,
        cardiacICU: normalizedData.field_cardiac_icu ? `${normalizedData.field_cardiac_icu} Beds` : null,
        surgicalICU: normalizedData.field_surgical_icu ? `${normalizedData.field_surgical_icu} Beds` : null,
        pediatricICU: normalizedData.field_pediatric_icu ? `${normalizedData.field_pediatric_icu} Beds` : null,
        neonatalICU: normalizedData.field_neonatal_icu ? `${normalizedData.field_neonatal_icu} Beds` : null,
        burnCare: normalizedData.field_burn_care ? `${normalizedData.field_burn_care} Beds` : null,
        physicalRehab: normalizedData.field_physical_rehab ? `${normalizedData.field_physical_rehab} Beds` : null,
        psychiatricCare: normalizedData.field_psychiatric_care ? `${normalizedData.field_psychiatric_care} Beds` : null,
        hospice: normalizedData.field_hospice,
        eolService: normalizedData.field_eol_service,
        traumaCenterLevel: normalizedData.field_trauma_center,
        traumaCenterIndicator: normalizedData.field_trauma_center_indicator,
        positronEmission: normalizedData.field_positron_emission,
        mri: normalizedData.field_mri,
        metatags: normalizedData.metatag_normalized,
        medicalSchools: normalizedData.field_med_school_relationship ?
          MedicalSchoolModel.parseMedicalSchool(normalizedData.field_med_school_relationship.dataset) as MedicalSchoolModel[] :
          [],
        field_member_aha_group: normalizedData.field_member_aha_group ? normalizedData.field_member_aha_group.dataset.data.attributes.name : null,
      });

    if (!Array.isArray(inst) && normalizedData.field_med_school_relationship) {
      let instJson: any;
      try {
        instJson = JSON.parse(institutionJson);
      } catch (e) {
        // data already in JSON
        instJson = institutionJson;
      }
      const medSchoolRelationships = normalize(instJson.data.relationships.field_med_school_relationship);
      inst.medicalSchools.forEach(ms => {
        ms.relationship = medSchoolRelationships.dataset.data.find(data => data.id === ms.id).meta.value;
      });
    }

    return inst;
  }

  public id: string;
  public institutionNumber: string;
  public imageUrl: string;
  public name: string;
  public geoLocation: any;
  public address: AddressModel;
  public serviceType: string;
  public ownershipType: string;
  public fullTimePersonnel: number;
  public numOfBeds: number;
  public numOfBassinet: number;
  public avgDailyCensus: number;
  public annualBirths: number;
  public annualAdmissions: number;
  public annualEdVisits: number;
  public annualNonEdVisits: number;
  public inpatientSurgeries: number;
  public outpatientSurgeries: number;
  public annualMedicareDischarge: number;
  public annualMedicaidDischarge: number;
  public cardiacICU: string;
  public surgicalICU: string;
  public pediatricICU: string;
  public neonatalICU: string;
  public burnCare: string;
  public physicalRehab: string;
  public psychiatricCare: string;
  public hospice: boolean;
  public eolService: boolean;
  public traumaCenterLevel: number;
  public traumaCenterIndicator: boolean;
  public positronEmission: number;
  public mri: boolean;
  public metatags: any;

  public medicalSchools: MedicalSchoolModel[];
  public field_member_aha_group;

  /**
   * Used by maps to determine to display map info window
   */
  public isOpen = false; // NOTE: if more is needed for display purpose, may need to create a view model used for maps.

  constructor(values?: Partial<InstitutionModel>) {
    super(values);
    Object.assign(this, values);
  }
}
